// extracted by mini-css-extract-plugin
module.exports = {"container":"GraphInfoTabs_container__2cT6w","tab":"GraphInfoTabs_tab__jL73h","active":"GraphInfoTabs_active__3rhWa"};